import React from 'react'
import WorkSection from './Sections/WorkSection'

const RegisterPage = () => {
    return (
        <div className="my-5">
            <WorkSection/>
        </div>
    )
}

export default RegisterPage
